import React, { useState } from "react";
import Header from "@/components/Header";
import IngestStatusBanner from "@/components/IngestStatusBanner";
import FiltersBar from "@/components/FiltersBar";
import SummaryCards from "@/components/SummaryCards";
import TokenBreakdownChart from "@/components/TokenBreakdownChart";
import CostChart from "@/components/CostChart";
import SessionsTable from "@/components/SessionsTable";
import EventsTable from "@/components/EventsTable";
import SetupPanel from "@/components/SetupPanel";
import IngestTokensPanel from "@/components/IngestTokensPanel";
import UsersPanel from "@/components/UsersPanel";
import RawPayloadPanel from "@/components/RawPayloadPanel";
import { useAuth } from "@/context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [filters, setFilters] = useState({ range: "week", from: null, to: null, user: null, model: null, session: null, token: null });

  return (
    <div className="min-h-screen bg-background" data-testid="dashboard">
      <Header />
      <IngestStatusBanner />
      <FiltersBar filters={filters} setFilters={setFilters} />

      <main className="px-4 lg:px-6 py-6 space-y-6 max-w-[1600px] mx-auto animate-fade-in">
        <SummaryCards filters={filters} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <TokenBreakdownChart filters={filters} />
          <CostChart filters={filters} />
        </div>

        <SessionsTable filters={filters} setFilters={setFilters} />
        <EventsTable filters={filters} />
        {isAdmin && <RawPayloadPanel />}
        {isAdmin && <UsersPanel />}
        <IngestTokensPanel />
        <SetupPanel />

        <p className="font-mono text-[11px] text-muted-foreground/60 text-center pt-4">
          Numbers are telemetry-derived and near-real-time depending on Claude Code export interval &amp; network latency.
        </p>
      </main>
    </div>
  );
}
